import {formatDate} from '@/shared/lib/i18n/formatDate';

export type LegalInfo = {
  company: string;
  address: string;
};

export const BUMPY_GROUP: LegalInfo = {
  company: 'MV Bumpy Group Limited',
  address: 'Strovolou 77, 4th floor office 401, 2018 Nicosia, Cyprus',
};

export const BUMPY_INC: LegalInfo = {
  company: 'Bumpy Inc.',
  address: '1007 N Orange St. 4th Floor, Wilmington, DE19801, USA',
};

export const LEGAL_VERSION = '2.0';
/**
 * should be ISO date: YYYY-MM-DDTHH:mm:ss (zero-padded, with time so it
 * is parsed as local, not UTC)
 */
export const LEGAL_EFFECTIVE_DATE = formatDate(
  new Date('2026-10-08T00:00:00'),
  'en'
);
/**
 * should be ISO date: YYYY-MM-DDTHH:mm:ss (zero-padded, with time so it
 * is parsed as local, not UTC)
 */
export const LEGAL_LAST_UPDATED = formatDate(
  new Date('2026-09-08T00:00:00'),
  'en'
);
export const LEGAL_REPLACES =
  'Bumpy Cookie Policy v1.0 and the Wonder Cookie Policy v1.0 referenced in the 2024 live package';
